import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useAgentMetrics = () => {
  const { toast } = useToast();
  
  const { data: agentMetrics, refetch } = useQuery({
    queryKey: ['agent-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('agent_learning')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    },
  });

  useEffect(() => {
    const channel = supabase
      .channel('agent-metrics-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'agent_learning'
        },
        (payload) => {
          console.log('Real-time update received:', payload);
          toast({
            title: "Agent Metrics Updated",
            description: "New agent performance data received"
          });
          refetch();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [refetch, toast]);

  return { agentMetrics };
};